import { apiClient } from './apiClient';

export interface TenantConfig {
  enableExternalAccessRestrictionsForChatParticipants: boolean;
  enableMutualFederationForChatParticipants: boolean;
}

class TenantConfigService {
  async getTenantConfig(): Promise<TenantConfig> {
    const response = await apiClient.get<Partial<TenantConfig>>('/tenant-config');
    const data = response?.data || {};
    return {
      enableExternalAccessRestrictionsForChatParticipants:
        data.enableExternalAccessRestrictionsForChatParticipants ?? false,
      enableMutualFederationForChatParticipants:
        data.enableMutualFederationForChatParticipants ?? false,
    };
  }

  async updateTenantConfig(patch: Partial<TenantConfig>): Promise<void> {
    await apiClient.patch('/tenant-config', patch);
  }
}

export const tenantConfigService = new TenantConfigService();
